import { render } from "./Notification.vue?vue&type=template&id=051e559a&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=051e559a&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051e559a"]])

export default __exports__